/// <amd-module name="Core/Medius.Core.Web/Scripts/AdminPages/Company/PaymentDetailsHandlingType"/>
export enum PaymentDetailsHandlingType {
    Disabled,
    UsePaymentDetails,
    ValidatePaymentDetails
}
